import { BaseRoutes } from "../../../utils/routes";

const isInvestorProfileId = (investorId: string) => {
  return investorId?.toString()?.startsWith("invp_");
};

export const getInvestorDetailsUrl = (investorId: string) => {
  const encodedId = encodeURIComponent(investorId);
  if (isInvestorProfileId(investorId)) {
    return `${BaseRoutes.INVESTOR_PROFILES}/${encodedId}`;
  }
  return `${BaseRoutes.INVESTORS}/${encodedId}`;
};

/** Investors v1 is available for BSE tenants, or RTA tenants that are not AMCs. */
export const isInvestorsV1Accessible = (
  supportedGateways: { bse?: boolean; rta?: boolean } | null | undefined,
  isAmcTenant: boolean
) => {
  if (supportedGateways?.bse === true) {
    return true;
  }

  return supportedGateways?.rta === true && !isAmcTenant;
};
